import React from "react";

import FormResetPassword from "../../components/Forms/ResetPassword/ResetPassword";
function ResetPassword() {
  return <FormResetPassword />;
}

export default ResetPassword;
